import { Slot } from "@radix-ui/react-slot";
import { LinkWrapper, } from "../components/LinkWrapper";
import { cn } from "../lib/utils";
import { cva } from "class-variance-authority";
import React from "react";
export const HOVERABLE_VARIANTS = [
    "invisible",
    "primary",
    "highlight",
];
const hoverableVariants = {
    invisible: cn("hover:text-highlight-light", "active:text-highlight-dark"),
    primary: cn("font-medium", "text-foreground", "hover:text-highlight-light", "active:text-highlight-dark"),
    highlight: cn("font-medium", "text-highlight", "hover:text-highlight-light", "active:text-highlight-dark"),
};
const variantStyle = cva("cursor-pointer duration-200 hover:underline hover:underline-offset-2", {
    variants: {
        variant: hoverableVariants,
    },
    defaultVariants: {
        variant: "invisible",
    },
});
const MetaHoverable = React.forwardRef(({ className, variant, asChild = false, children, ...props }, ref) => {
    const Comp = asChild ? Slot : "span";
    return (React.createElement(Comp, { className: cn(variant && variantStyle({ variant }), className), ref: ref, ...props }, children));
});
MetaHoverable.displayName = "MetaHoverable";
const Hoverable = React.forwardRef(({ href, target, rel, children, variant, className, ...props }, ref) => {
    const innerElement = (React.createElement(MetaHoverable, { ref: ref, variant: variant, className: className, ...props }, children));
    return href ? (React.createElement(LinkWrapper, { href: href, target: target, rel: rel }, innerElement)) : (innerElement);
});
Hoverable.displayName = "Hoverable";
export { Hoverable };
//# sourceMappingURL=Hoverable.js.map